export const AVAILABLE_IMAGE_WIDTH = [90, 180, 360, 540, 768, 1024, 1280, 1366, 1440, 1600, 1680, 1920, 2560];
export const MAX_IMAGE_WIDTH = _.last(AVAILABLE_IMAGE_WIDTH);



// WEBPACK FOOTER //
// ./src/widget/constants/image-sizes.js